<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="" id="passwordmodallabel">Manually Reset Password </h5>
      <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close" (click)="resetForm('passwordmodal',newPasswordFrm)">
        <span aria-hidden="true">&times;</span>
      </button>

    </div>
    <form [formGroup]="newPasswordFrm" id="passwordmodalform" (ngSubmit)="resetpasswordmanual()">
      <div class="modal-body">
        <div *ngIf="manualPasswordReset" class="{{manualPasswordAlertClass}} | sanitize" role="alert" id="manualPasswordMessageBox">
          <strong>Attention!</strong> {{manualPasswordReset}}
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label>Username</label>
            <input class="form-control" type="text" disabled [ngModel]="UserPasswordReset.username" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="form-group col-md-12">
            <label for="password" class="form-control-label">New Password</label>
            <div class="input-group">
              <input type="{{passwordType}}" formControlName="new-password" class="form-control" id="new-password" name="new-password" autocomplete="off" />
              <div class="input-group-append">
                <button class="btn btn-secondary" type="button" (click)="showPassword(this)" title="Reveal password"><i class="far fa-eye"></i></button>
              </div>
            </div>
            <div class="alert alert-danger" role="alert" *ngIf="newPasswordFrm.controls['new-password'].invalid && !newPasswordFrm.pristine">
              <div>
                Your new password must contain the following:
                <ul>
                  <li>At least 8 characters</li>
                  <li>At least 1 uppercase and 1 lowercase character</li>
                  <li>At least 1 number</li>
                  <li>At least 1 of the following characters: .!&#64;#$%^&*(),?"|<></li>
                </ul>
              </div>
            </div>
            <div class="alert alert-danger" role="alert" *ngIf="matchPassword()">
              <small>
                Please make sure both password inputs match.
              </small>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="repeat-password" class="form-control-label">Confirm New Password</label>
            <input type="{{passwordType}}" formControlName="repeat-password" class="form-control" id="repeat-password" name="repeat-password" autocomplete="off" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary pull-left" data-dismiss="modal" (click)="resetForm('passwordmodal',newPasswordFrm)">Cancel</button>
        <div class="loading-indicator login-btn-container" *ngIf="!submitted">
          <button type="submit" class="btn btn-primary" [disabled]="newPasswordFrm.invalid || newPasswordFrm.pristine || matchPassword()" name="submitbutton">Change Password</button>
        </div>
        <div class="loading-indicator login-btn-container" *ngIf="submitted">
          <button class="btn  btn-danger"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Submitting...</button>
        </div>
      </div>
    </form>
    


  </div>
</div>
